/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Arbeitstreffen_Begleiten27Inputs */

const en__field_enum_tuda_arbeitstreffen_begleiten27 = /** @type {(inputs: _Field_Enum_Tuda_Arbeitstreffen_Begleiten27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fllow your mentor in one of his meetings`)
};

const de__field_enum_tuda_arbeitstreffen_begleiten27 = /** @type {(inputs: _Field_Enum_Tuda_Arbeitstreffen_Begleiten27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentor/ Mentorin zu Arbeitstreffen begleiten (Meetings, Messen, etc.)`)
};

/**
* | output |
* | --- |
* | "Fllow your mentor in one of his meetings" |
*
* @param {_Field_Enum_Tuda_Arbeitstreffen_Begleiten27Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_arbeitstreffen_begleiten27 = /** @type {((inputs?: _Field_Enum_Tuda_Arbeitstreffen_Begleiten27Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Arbeitstreffen_Begleiten27Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_arbeitstreffen_begleiten27(inputs)
	return de__field_enum_tuda_arbeitstreffen_begleiten27(inputs)
});
export { _field_enum_tuda_arbeitstreffen_begleiten27 as "_field_enum_TUDA_ARBEITSTREFFEN_BEGLEITEN" }